import { Injectable } from '@angular/core';
import { Config } from './analytics-initializer';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsConfigService {
  private static readonly default: Required<Config> = {
    isDisabled: false,
    debug: [],
    verbose: false,
    labelOverride: new Map(),
    action: new Map(),
    category: new Map(),
    excludeTags: [],
    googleAnalyticsCookie: '_ga',
    pageType: []
  };

  private config: Config = AnalyticsConfigService.default;

  getConfig() {
    return this.config;
  }

  setConfig(config: Config) {
    this.config = {
      ...AnalyticsConfigService.default,
      ...config
    };
  }
}
